import { createQuestions } from "../js/createQuestions";
import Toastify from "toastify-js";

const createAssessment = () => {
  // create questions
  createQuestions();

  // get the student form
  let form = document.getElementById("quiz");

  // check if the form exists in the DOM
  if (form) {
    // create submit event listener

    form.addEventListener("submit", (ev) => {
      // Prevent form submission
      ev.preventDefault();

      // Get form data
      const inputs = form.querySelectorAll("input");
      let total = 0;
      inputs.forEach((input) => {
        if (input.name.startsWith("question_")) {
          total += parseInt(input.value);
        }
      });

      const data = new FormData(form);
      data.append("action", "create_assessment");
      data.append("score", total);

       console.log([...data]);

      // Make the AJAX request
      fetch("/wp-admin/admin-ajax.php", {
        method: "POST",
        body: data,
      })
        .then((response) => response.json())
        .then((response) => {
          // Handle the response
          console.log(response.data);

          Toastify({
            text: response.data.message,
            duration: 2000,
            gravity: "bottom", // `top` or `bottom`
            position: "right", // `left`, `center` or `right`,
            className: "rounded-md shadow",
            style: {
              background: "#000000",
            },
            callback: () => {
              if (response.data.success) {
                window.location.href = "/results";
              }
            },
          }).showToast();
        })
        .catch((error) => {
          // Handle any errors
          console.error(error);
        });
    });
  }
};

export { createAssessment };
